import { FetchResultsStatusType, MattressSizeOptions } from "./constants";
import { IReduxState } from "./reducers.interfaces";

export const defaults: IReduxState = {
    ui: {
        selections: {
            selectedSize: MattressSizeOptions.QUEEN,
            selectedSleepPosition: 0,
            selectedHeight: 0,
            selectedWeight: 0,
            selectedCoolness: 0,
            selectedBudget: 0,
        },
        loadedResults: null,
        fetchResultsStatus: FetchResultsStatusType.IDLE,
        currentScreen: 0,
    },
};
